import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_CALENDAR_SETTINGS,
    GET_ANNOUNCEMENTS,
    SET_CALENDAR_SETTINGS,
    GENERATE_NEW_CALENDAR_SHARING_LINK,
    SET_CANCEL_CALENDAR_SHARING,
    GET_ACCOUNT_DATA,
    SET_FAVORITE,
    GET_ACCOUNT_DETAILS,
    UPDATE_ACCOUNT_DETAILS,
    GET_LINKS,
    GET_PHYSICIAN_DETAILS,
    SET_FAVORITE_PHYSICIAN,
    GET_PHYSICIAN_DATA,
    UPDATE_PHYSICIAN_NOTE,
    GET_ACCOUNTS,
    GET_TERRITORY,
    GET_ACCOUNTS_LIST,
    GET_DISTRICT,
    GET_PRODUCTSTEMPLATESFILTER,
    GET_DISTRICT_PHYSICIAN,
    GET_PHYSICIAN_FAV_STATUS,
    GET_ACCOUNT_FAV_STATUS,
    GET_SPECIALTY_FILTER_DATA,
    GET_FIELD_INVENTORY_DASHBOARD,
    ADD_FIM_NOTES,
    GET_DASHBOARD_LIST,
    DASHBOARD_EXPORT,
    GET_ALLOCATION_DETAILS,
    ALLOCATE_SET,
    REJECT_SET,
    GET_SET_DETAILS,
    GET_REJECT_SET_REASONS
} from '../actions';

import {
    getCalendarSettings,
    getNewCalendarLink,
} from './getCalendarSettingsSaga';
import getProductsTemplates from './templateSaga';
import setCalendarSettings from './setCalendarSettingsSaga';
import getAnnouncements from './announcementSaga';
import cancelCalendarSharing from './cancelCalendarSharingSaga';
import {
    getAccountDetails,
    getAccountDetailss,
    setFavoriteIcon,
    updateAccountDetails,
    getPhysicianDetailss,
    setFavoritePhysician,
    getPhysicianDetails,
    updatePhysicianNote,
    getFavPhysicianStatus,
    getFavAccountStatus,
    getAccountList,
    getSpecialtyFilterData,
} from './getAccountsSaga';
import getAccount from './getAccountsSaga';
import getDistrictView from './accountDistrictSaga';
import getDistrictViewPhysician from './physicianDistrictSaga';
import getTerritory from './accountTerritorySaga';
import { getLinks } from './getLinksSaga';
import rejectSet from './rejectSetSaga';
import getSetDetails from './getSetDetailsSaga';
import getRejectSetReasons from './rejectSetReasonsSaga';
function* watchGetCalendarSettings() {
    yield takeEvery(GET_CALENDAR_SETTINGS, getCalendarSettings);
    yield takeEvery(GENERATE_NEW_CALENDAR_SHARING_LINK, getNewCalendarLink);
}

function* watchSetCalendarSettings() {
    yield takeLatest(SET_CALENDAR_SETTINGS, setCalendarSettings);
}

function* watchGetAnnouncements() {
    yield takeEvery(GET_ANNOUNCEMENTS, getAnnouncements);
}

function* watchCancelCalendarSharing() {
    yield takeEvery(SET_CANCEL_CALENDAR_SHARING, cancelCalendarSharing);
}

function* watchGetAccountDetails() {
    yield takeLatest(GET_ACCOUNT_DATA, getAccountDetails);
}

function* watchGetAccountDetailss() {
    yield takeLatest(GET_ACCOUNT_DETAILS, getAccountDetailss);
}
function* watchUpdateAccountDetails() {
    yield takeLatest(UPDATE_ACCOUNT_DETAILS, updateAccountDetails);
}

function* watchSetFavorite() {
    yield takeLatest(SET_FAVORITE, setFavoriteIcon);
}

function* watchGetLinksData() {
    yield takeLatest(GET_LINKS, getLinks);
}

// function* watchGetShipToAddressDetails(){
//     yield takeLatest(GET_SHIP_TO_ADDRESS_DATA, getShipToAddressDetails);
// }

function* watchGetPhysicianDetailss() {
    yield takeLatest(GET_PHYSICIAN_DETAILS, getPhysicianDetailss);
}
function* watchGetPhysicianFavourite() {
    yield takeLatest(SET_FAVORITE_PHYSICIAN, setFavoritePhysician);
}

function* watchGetPhysicianDetails() {
    yield takeLatest(GET_PHYSICIAN_DATA, getPhysicianDetails);
}

function* watchUpdatePhysicianNote() {
    yield takeLatest(UPDATE_PHYSICIAN_NOTE, updatePhysicianNote);
}

function* watchAccountDistrictData() {
    yield takeEvery(GET_DISTRICT, getDistrictView);
}
function* watchAccountDistrictPhysicianData() {
    yield takeEvery(GET_DISTRICT_PHYSICIAN, getDistrictViewPhysician);
}

function* watchAccountTerritoryData() {
    yield takeEvery(GET_TERRITORY, getTerritory);
}

function* watchAccountFilterAccountData() {
    yield takeEvery(GET_ACCOUNTS, getAccount);
}
function* watchPhysicianFilterAccountData() {
    yield takeEvery(GET_ACCOUNTS_LIST, getAccountList);
}
function* watchTemplateFilterData() {
    yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, getProductsTemplates);
}
function* watchGetFavPhysicianStatus() {
    yield takeEvery(GET_PHYSICIAN_FAV_STATUS, getFavPhysicianStatus);
}
function* watchGetFavAccountStatus() {
    yield takeEvery(GET_ACCOUNT_FAV_STATUS, getFavAccountStatus);
}
function* watchGetSpecialtyFilterData() {
    yield takeEvery(GET_SPECIALTY_FILTER_DATA, getSpecialtyFilterData);
}

import getFieldInventoryDashboard from './fieldInventoryDashboardSaga';
import dashboardExport from './dashboardExportSaga';
import addFimNotesSaga from './fimAddNotesReducerSaga';
import getDashboardList from './dashboardListSaga';
import getAllocationDetailsSaga from './allocationDetailsSaga';
import allocateSetSaga from './allocateSetSaga';
import { watchFetchFilters, watchSaveFilters } from './dashboardFiltersSaga';

function* watchGetFieldInventoryDashboard() {
    yield takeEvery(GET_FIELD_INVENTORY_DASHBOARD, getFieldInventoryDashboard);
}

function* watchDashboardExport() {
    yield takeLatest(DASHBOARD_EXPORT, dashboardExport);
}

function* watchAddFimNotes() {
    yield takeLatest(ADD_FIM_NOTES, addFimNotesSaga);
}

function* watchGetDashboardList() {
    yield takeLatest(GET_DASHBOARD_LIST, getDashboardList);
}

function* watchGetAllocationDetails() {
    yield takeLatest(GET_ALLOCATION_DETAILS, getAllocationDetailsSaga);
}

function* watchAllocateSet() {
    yield takeLatest(ALLOCATE_SET, allocateSetSaga);
}

function* watchRejectSet() {
    yield takeEvery(REJECT_SET, rejectSet);
}

function* watchGetSetDetails() {
    yield takeLatest(GET_SET_DETAILS, getSetDetails);
}

function* watchRejectSetReasons() {
    yield takeLatest(GET_REJECT_SET_REASONS, getRejectSetReasons);
}
export default function* MoreSaga() {
    yield all([
        fork(watchGetCalendarSettings),
        fork(watchSetCalendarSettings),
        fork(watchGetAnnouncements),
        fork(watchCancelCalendarSharing),
        fork(watchGetAccountDetails),
        fork(watchGetAccountDetailss),
        fork(watchUpdateAccountDetails),
        fork(watchSetFavorite),
        fork(watchGetLinksData),
        fork(watchGetPhysicianDetails),
        fork(watchGetPhysicianDetailss),
        fork(watchGetPhysicianFavourite),
        fork(watchUpdatePhysicianNote),
        fork(watchAccountDistrictData),
        fork(watchAccountDistrictPhysicianData),
        fork(watchAccountTerritoryData),
        fork(watchAccountFilterAccountData),
        fork(watchTemplateFilterData),
        fork(watchGetFavPhysicianStatus),
        fork(watchGetFavAccountStatus),
        fork(watchPhysicianFilterAccountData),
        fork(watchGetSpecialtyFilterData),
        fork(watchGetFieldInventoryDashboard),
        fork(watchDashboardExport),
        fork(watchAddFimNotes),
        fork(watchGetDashboardList),
        fork(watchGetAllocationDetails),
        fork(watchAllocateSet),
        fork(watchRejectSet),
        fork(watchFetchFilters),
        fork(watchSaveFilters),
        fork(watchGetSetDetails),
        fork(watchRejectSetReasons),
        // fork(watchGetShipToAddressDetails),
    ]);
}
